<template>
  <div class="flex items-start justify-start">
    <div class="flex">
      <!-- Mensaje de éxito -->
      <div v-if="msg" class="user-alert">
        <div class="user-alert-content">
          <div class="user-alert-text">
            {{ msg }}
          </div>
        </div>
      </div>
    </div>

    <div class="w-full p-4">
      <form @submit.prevent="saveNetworksCompany"> <!-- Formulario -->
        <div class="flex flex-col sm:flex-row mt-4 sm:mt-10">
          <div class="w-full sm:w-1/2 mb-5">
            <div class="flex justify-center items-center text-2xl font-bold">
              Redes sociales de la compañía
            </div>
            <div 
              v-for="(item, index) in networks_company"
              :key="item.id"
              class="flex mt-5"
            >
              <div class="w-[20%] sm:w-[15%] p-2 flex justify-center items-center">
                <div v-html="item.icon" />
              </div>

              <div class="w-[80%] sm:w-[75%] p-2">
                <input
                  type="url"
                  v-model="networks_company [index].link_company"
                  :placeholder="getPlaceholder(item.name)"
                  size="sm"
                  class="w-full px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"   
                  pattern="https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)"
                  title="Ingrese una URL válida comenzando con http:// o https://"
                />
              </div>
            </div>

            <div class="flex mt-5 justify-center items-center">
              <button 
                type="submit" 
                class="custom-create-btn"
              >
                <span class="custom-create-btn-text">Guardar</span>
              </button>
            </div>         
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { useRoute } from "vue-router";

let networks_company = ref([]);
const route = useRoute();
const companyId = computed(() => route.params.id);  // Obtener el ID de la compañía desde la URL
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

const store = useStore();
let session = computed(() => store.getters.getUserSession);

onMounted(async () => {
  try {
    await getNetworks();    
  } catch (error) {
    console.error("Error al intentar traer los datos", error);
  }
});

const placeholders = {
  facebook: "https://facebook.com/tu-empresa",
  twitter: "https://x.com/tu-empresa",
  instagram: "https://instagram.com/tu-empresa",
  linkedin: "https://linkedin.com/company/tu-empresa",
  youtube: "https://youtube.com/c/tu-empresa",
  tiktok: "https://www.tiktok.com/@tu-empresa",
};

const getPlaceholder = (networkName) => {
  return placeholders[networkName.toLowerCase()] || "https://ejemplo.com";
};

async function getNetworks() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get (`${process.env.VUE_APP_API_BASE_URL}/networks/${companyId.value}`, options);

    if (response.status == 401) {
      store.dispatch("clearUser Session");
    }

    if (response.status == 200) {
      networks_company.value = response.data.data;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function saveNetworksCompany() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };

    let params_item = [];

    networks_company.value.forEach(item => {
      let row = {};
      row['id'] = item.id;
      row['link_company'] = item.link_company;
      row['user_id'] = session.value.id;
      row['company_id'] = companyId.value;

      params_item.push(row);
    });

    let params = {
      type: "company",
      step: 3,
      networks: params_item,
    };

    const response = await axios.put(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${companyId.value}/update-networks`,
      params,
      options        
    );

    if (response.status == 200) {
      store.dispatch('updateStep', 3);
      showToast('success', 'Redes sociales guardadas correctamente');

      // Limpiar el mensaje después de 5 segundos
      setTimeout(() => {
        msg.value = '';
      }, 3000);
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    if (error.response) {
      console.error("Error de respuesta del servidor:", error.response.data);
    }
    showToast('danger', 'No se pudo guardar las redes sociales en este momento');
  }
}

async function showToast(type = null, message = null) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}
</script>

<style>
.user-alert {
  background-color: #d4edda; /* Color de fondo para el mensaje de éxito */
  border: 1px solid #c3e6cb; /* Borde del mensaje */
  color: #155724; /* Color del texto */
  padding: 10px;
  border-radius: 5px;
  margin-top: 10px;
}
</style>